import React, { useState } from 'react'; 
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroupItem } from 'reactstrap';
import { t } from 'i18next';
import axios from 'axios';
import { BACKEND_URL_DOC, BACKEND_URL_LOG } from '../../../config/const';
import './PapperStyle.css'

const Supprimer = ({ ItemId, name ,idOrganisation}) => {
    const [open, setOpen] = useState(false);
    const [openDelSucc, setOpenDelSucc] = useState(false);
    const [openDelError, setOpenDelError] = useState(false);

    const handleToggle = () => setOpen(!open);
    const handleToggleDelSucc = () => setOpenDelSucc(!openDelSucc);
    const handleToggleDelError = () => setOpenDelError(!openDelError);

    const deleteItem = async () => {
        
        const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            },
            data : { 
                idCleanRoom: ItemId,
                idOrganisation:idOrganisation
             }
          };
    

        try {
            // Premier appel API
            await axios.delete(`${BACKEND_URL_LOG}deleteCleanRoom`,  config);

            // Deuxième appel API
           /*  await axios.delete(`${BACKEND_URL_DOC}deleteCleanRoom`,  config);
 */
            setOpen(false);
            setOpenDelSucc(true);
        } catch (error) {
            setOpen(false);
            setOpenDelError(true);
        }
    };
    


    return (
        <>
            <button className="btn btn-primary ContactBtn" onClick={handleToggle}>{t('DELETE')}</button>
            
            <Modal isOpen={open} toggle={handleToggle} centered size="lg">
                <ModalHeader toggle={handleToggle}>{t('DELETE')}</ModalHeader>
                <ModalBody>
                    {t('MessageDeletedCleanroom')} {name}
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary" onClick={handleToggle}>{t('cancel')}</button>
                    <button className="btn btn-primary" onClick={deleteItem}>{t('DELETE')}</button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={openDelSucc} toggle={handleToggleDelSucc} centered size="lg">
                <ModalBody className="text-center">
                    <ListGroupItem className="text-success">
                        <i className="bi bi-check-circle-fill"></i> {name} {t('Deletedsuccessfully')}
                    </ListGroupItem>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary" onClick={() => window.location.reload()}>{t('Ok')}</button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={openDelError} toggle={handleToggleDelError} centered size="lg">
                <ModalBody className="text-center">
                    <ListGroupItem className="text-danger">
                        <i className="bi bi-x-circle-fill"></i> {name} {t('DeletefailedCleanroom')}
                    </ListGroupItem>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary" onClick={handleToggleDelError}>{t('Ok')}</button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Supprimer;
